import React from "react";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import AddIcon from "@mui/icons-material/Add";
import AddToPhotosIcon from "@mui/icons-material/AddToPhotos";
import RefreshIcon from "@mui/icons-material/Refresh";
import { withStyles } from "@mui/styles";
import PropTypes from "prop-types";

const defaultToolbarStyles = {
  iconButton: {},
};

const CustomToolbar = (props) => {
  const { classes, handleClick, handleReload, handleClickCollection } = props;

  return (
    <React.Fragment>
      <Tooltip title={"Reload"}>
        <IconButton className={classes.iconButton} onClick={handleReload}>
          <RefreshIcon className={classes.deleteIcon} />
        </IconButton>
      </Tooltip>
      <Tooltip title={"Add MenuItem"}>
        <IconButton className={classes.iconButton} onClick={handleClick}>
          <AddIcon className={classes.deleteIcon} />
        </IconButton>
      </Tooltip>
      {handleClickCollection && (
        <Tooltip title={"Add Collection"}>
          <IconButton className={classes.iconButton} onClick={handleClickCollection}>
            <AddToPhotosIcon className={classes.deleteIcon} />
          </IconButton>
        </Tooltip>
      )}
    </React.Fragment>
  );
};

CustomToolbar.propTypes = {
  classes: PropTypes.object,
  handleClick: PropTypes.func.isRequired,
  handleReload: PropTypes.func.isRequired,
};

export default withStyles(defaultToolbarStyles, { name: "CustomToolbar" })(CustomToolbar);
